import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $("#default-portfolio").sortable({
      handle: ".handle",
      nested: false,
      vertical: false,
      placeholder:
        "portfolio_coin col-12 col-sm-6 col-lg-4 col-xl-3 col-xxl-5-cols dashboard-favourite ui-sortable-placeholder portfolio-placeholder portfolio_coin",
      items: ".portfolio_coin:not(.locked)",
      start() {
        $(".price-highlight-placeholder").css("z-index", 9999);

        // Inspired from http://stackoverflow.com/questions/4299241/jquery-sortable-lists-and-fixed-locked-items
        return $(".locked", this).each(function() {
          const $this = $(this);
          return $this.data("pos", $this.index() - 2);
        });
      },

      //# Hack minus 2 to make it work here for some unknown reason :(
      change() {
        const $sortable = $(this);
        const $statics = $(".locked", this).detach();
        const $helper = $(
          '<div class="col-md-4" style="border: 1px solid rgb(239, 239, 239); height: 512px; "></div>'
        ).prependTo(this);
        $statics.each(function() {
          const $this = $(this);
          const target = $this.data("pos");
          return $this.insertAfter($(".portfolio_coin", $sortable).eq(target));
        });
        return $helper.remove();
      },

      stop() {
        return $(".price-highlight-placeholder").css("z-index", -9999);
      },

      update() {
        return $.post($(this).data("update-url"), $(this).sortable("serialize"));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/portfolios_controller.js